import { createContext, useContext, useState, useRef, Suspense, type ReactNode } from 'react';
import Box from '@mui/material/Box';
import { NyomiriSkeletonGrid } from './skeletons/NyomiriSkeletons.tsx';

const ActiveViewContext = createContext(true);
export const useViewActive = () => useContext(ActiveViewContext);

/** Mount on the first visit and retain UI state for this browser session. */
export function RetainedView({ active, children }: { active: boolean; children: ReactNode }) {
  const retainedChildren = useRef(children);
  if (active) retainedChildren.current = children;
  const [visited, setVisited] = useState(active);
  if (active && !visited) setVisited(true);
  if (!active && !visited) return null;
  return (
    <ActiveViewContext.Provider value={active}>
      <Box data-y-view={active ? "active" : "hidden"} hidden={!active} sx={{ display: active ? 'block' : 'none' }}>
        <Suspense fallback={<NyomiriSkeletonGrid count={12} />}>
          {retainedChildren.current}
        </Suspense>
      </Box>
    </ActiveViewContext.Provider>
  );
}
